var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { HttpClient } from '@angular/common/http';
import { Observable, Subscriber } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { LocalizationService } from './localization.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./auth.service";
import * as i3 from "./localization.service";
var UserNotificationService = /** @class */ (function () {
    function UserNotificationService(http, authService, baseUrl, localizationService) {
        this.http = http;
        this.authService = authService;
        this.baseUrl = baseUrl;
        this.localizationService = localizationService;
        this.apiUrl = this.baseUrl + "api/user/notifications";
    }
    UserNotificationService.prototype.getUserNotification = function (triggerId) {
        var _this = this;
        return new Observable(function (subscriber) {
            _this.getUserNotificationCall(triggerId, subscriber);
            _this.localizationService.addLangSubscriber(subscriber, function (obs) {
                return _this.getUserNotificationCall(triggerId, obs);
            });
        });
    };
    UserNotificationService.prototype.getUserNotificationCall = function (triggerId, subscriber) {
        return this.http
            .get(this.apiUrl + "/" + triggerId)
            .subscribe(function (nots) { return subscriber.next(nots); }, function (error) { return subscriber.error(error); });
    };
    UserNotificationService.prototype.getUserNotifications = function () {
        var _this = this;
        return new Observable(function (subscriber) {
            _this.getUserNotificationsCall(subscriber);
            _this.localizationService.addLangSubscriber(subscriber, function (obs) {
                return _this.getUserNotificationsCall(obs);
            });
        });
    };
    UserNotificationService.prototype.getUserNotificationsCall = function (subscriber) {
        this.http.get("" + this.apiUrl).subscribe(function (mods) { return subscriber.next(mods); }, function (error) { return subscriber.error(error); });
    };
    UserNotificationService.prototype.putUserNotification = function (userNotificationModel) {
        // always an update, user can't create new
        return this.http
            .put(this.apiUrl + "/" + userNotificationModel.id, userNotificationModel)
            .pipe(map(function (_) {
            return __assign({}, userNotificationModel);
        }));
    };
    UserNotificationService.prototype.markRead = function (logId) {
        return this.http.post(this.apiUrl + "/markRead/" + logId, {});
    };
    UserNotificationService.prototype.sendPreview = function (triggerTypeId) {
        return this.http.post(this.apiUrl + "/sendPreview/" + triggerTypeId, {}, {
            observe: 'response'
        });
    };
    UserNotificationService.ngInjectableDef = i0.defineInjectable({ factory: function UserNotificationService_Factory() { return new UserNotificationService(i0.inject(i1.HttpClient), i0.inject(i2.AuthService), i0.inject("BASE_URL"), i0.inject(i3.LocalizationService)); }, token: UserNotificationService, providedIn: "root" });
    return UserNotificationService;
}());
export { UserNotificationService };
